<div class="collection-instructions" [style.--text-color]="textColor" [style.--color]="brandColor">
  <div class="title-wrapper">
    <div class="title">Collection instructions</div>
    <common-close-icon class="close-icon" (click)="closeDialog()" />
  </div>
  <div class="steps">
    <common-instructions-step [step]="InstructionsSteps.PACK" [brandColor]="brandColor" />
    <common-instructions-step [step]="InstructionsSteps.PRINT" [brandColor]="brandColor" [labelUrl]="labelUrl" />
    <common-instructions-step
      [step]="InstructionsSteps.GREET"
      [brandColor]="brandColor"
      [lastStep]="true"
      [deliveryPartner]="this.data.deliveryPartner" />
  </div>
  <button class="ok-button" (click)="closeDialog()">Got it</button>
</div>
